import { FC, ReactElement } from 'react';

interface IconButtonProps {
  icon: ReactElement;
  onClick: () => void;
  ariaLabel: string;
  className?: string;
  disabled?: boolean;
}

export const IconButton: FC<IconButtonProps> = ({
  icon,
  onClick,
  ariaLabel,
  className = '',
  disabled = false
}) => (
  <button
    onClick={onClick}
    aria-label={ariaLabel}
    disabled={disabled}
    className={`p-2 rounded-full transition-colors ${
      disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100 dark:hover:bg-gray-700'
    } ${className}`}
  >
    {icon}
  </button>
);